import { PlaylistAddCheck as PlaylistAddCheckIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { keyframes } from "@mui/material/styles";

interface JustifyAllStrandLossesButtonProps {
  isJustifying: boolean;
  onJustifyAll: () => void;
  iconFontSize?: number;
}

const DEFAULT_ICON_FONT_SIZE = 22;

const JUSTIFY_ALL_LABEL = "Justify all strand losses";

const attentionPulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.15); }
`;

export const JustifyAllStrandLossesButton = ({
  isJustifying,
  onJustifyAll,
  iconFontSize = DEFAULT_ICON_FONT_SIZE,
}: JustifyAllStrandLossesButtonProps) => (
  <Tooltip title={JUSTIFY_ALL_LABEL}>
    <span>
      <IconButton
        aria-label={JUSTIFY_ALL_LABEL}
        color="primary"
        disabled={isJustifying}
        onClick={(event) => {
          event.stopPropagation();
          onJustifyAll();
        }}
        onMouseDown={(event) => event.stopPropagation()}
        size="small"
        sx={{ p: 0.25 }}
      >
        <PlaylistAddCheckIcon
          sx={{
            animation: `${attentionPulse} 1.4s ease-in-out infinite`,
            fontSize: iconFontSize,
            transformOrigin: "center",
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
            },
          }}
        />
      </IconButton>
    </span>
  </Tooltip>
);
